import { Version } from "@/services/global-services/models";

/**
 * The day the "structured export" download option was introduced. Real versions get their
 * publicationDate stamped with the server's current time at the moment they're published
 * (see VersionManagementService.createVersion), so it can never be in the future relative
 * to "now" — comparing it against a moving `new Date()` would only ever be true on the exact
 * day a version was published. What we actually want is: does this version predate the
 * feature? Versions published before this fixed date won't have data for it, so only
 * versions published on or after this date (plus the in-progress "wip" preview) get the button.
 */
const STRUCTURED_EXPORT_LAUNCH_DATE = new Date(2026, 6, 27); // 27 July 2026

export function isStructuredExportAvailable(version?: Version): boolean {
    if (!version) return false;
    if (version.name === "wip") return true;

    const publicationDate = new Date(version.publicationDate);
    const publicationDay = new Date(
        publicationDate.getFullYear(),
        publicationDate.getMonth(),
        publicationDate.getDate()
    );

    return publicationDay >= STRUCTURED_EXPORT_LAUNCH_DATE;
}
